import styled from 'styled-components';

export const ForaEventos = styled.div`
  width: 1500px;
  margin: 0 auto;

  @media (max-width: 1550px) {
    width: 1100px;
  }

  @media (max-width: 1150px) {
    width: 800px;
  }

  @media (max-width: 850px) {
    width: 90%;
  }
`;

export const TextEventos1 = styled.div`
  font-family: 'Rubik', sans-serif;
  font-size: 50px;
  font-weight: bold;
  color: #b9b9b9;
  text-transform: uppercase;
  text-align: center;
  margin-top: 130px;
  margin-bottom: 100px;

  span {
    color: #ff6800;
  }

  @media (max-width: 1550px) {
    margin-top: 80px;
    margin-bottom: 90px;
  }

  @media (max-width: 1150px) {
    margin-top: 50px;
    margin-bottom: 60px;
  }

  @media (max-width: 650px) {
    font-size: 37px;
  }

  @media (max-width: 470px) {
    font-size: 37px;
    margin-top: 50px;
    margin-bottom: 20px;
  }
`;

export const ForaItensEventos = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ItemEvento = styled.div`
  width: 32%;
  margin-bottom: 25px;
  height: 286px;
  background-size: cover;
  background-position: center;
  cursor: pointer;

  :hover .OutTextEvento {
    display: flex;
  }

  @media (max-width: 1150px) {
    height: 170px;
  }

  @media (max-width: 850px) {
    width: 48%;
    margin-bottom: 5px;
  }

  @media (max-width: 450px) {
    height: 120px;
  }
`;

export const OutTextEvento = styled.div`
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  display: none;
`;

export const TextEvento = styled.div`
  color: #fff;
  font-size: 26px;
  width: 80%;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 1150px) {
    font-size: 20px;
  }  
  
  @media (max-width: 500px) {
    font-size: 17px;
  }
`;

export const ImagemEvento = styled.img`
  width: 100%;
  height: auto;
`;

export const TextItemEvento = styled.h1``;

export const ForaMaisEventos = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 175px;
  margin-top: 30px;
  cursor: pointer;

  @media (max-width: 650px) {
    margin-top: 15px;
  }
`;

export const TextMaisEventos = styled.h3`
  font-weight: 500;
  font-size: 16px;
  color: #3d3d3d;
  text-transform: uppercase;
`;

export const ForaImgSetaEventos = styled.div`
  margin-top: 20px;

  @media (max-width: 650px) {
    margin-top: 5px;
  }
`;

export const SetaEventos = styled.img``;

export const ForaSobraEventos = styled.div`
  margin: 0 auto;
  width: 1020px;

  @media (max-width: 1150px) {
    width: 90%;
  }
`;

export const ImagemSobraEventos = styled.img`
  @media (max-width: 1150px) {
    width: 100%;
    height: auto;
  }
`;

export const BgEvento = styled.div`
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: 100;
  background-color: rgb(20, 20, 20, 0.99);
`;

export const TextXEvento = styled.div`
  font-weight: bold;
  font-size: 32px;
  text-align: right;
  padding-top: 20px;
  padding-right: 45px;
  cursor: pointer;
`;

export const ForaEvento = styled.div`
  height: 90%;
  display: flex;
  align-items: center;
`;

export const ItemImgEvento = styled.div`
  width: 950px;
  margin: 0 auto;
  max-height: 86vh;
  height: 73vh;

  @media (max-width: 1240px) {
    height: 54vh;
  }

  @media (max-width: 850px) {
    height: 37vh;
  }

  @media (max-width: 600px) {
    height: 34vh;
  }
`;

export const ImgItemEvento = styled.img`
  width: 100%;
  height: auto;
`;
